export const CUSTOM_ERROR_CODE = "customErrorCode";

/* ------------------------------ Common error ------------------------------ */
export const FILE_REQUIRED = "validation/file.required";
